import React from 'react';
import { isValidPassword } from 'helpers/Account';
import CreatePassword from '../AccountComponents/CreatePassword';
import Style from '../SharedStyles/SharedStyles.module.scss';

function setCreatePasswordErrors(cb, name) {
  const { createPasswordNewPassword } = this.state;
  const createPasswordNewPasswordError = !isValidPassword(createPasswordNewPassword);
  const setStateCb = () => {
    const { createPasswordNewPasswordError } = this.state;
    const hasErrors = createPasswordNewPasswordError || false;
    if (cb) return cb(hasErrors);
    return hasErrors;
  };

  if (name) {
    switch (name) {
      case 'createPasswordNewPasswordError':
        this.setState({ createPasswordNewPasswordError }, setStateCb);
        break;
      default:
        break;
    }
  } else {
    return this.setState(
      {
        createPasswordNewPasswordError,
      },
      setStateCb,
    );
  }
  return null;
}

function onCreatePassword(isGoogle) {
  const {
    language: { profileError_passwordLength: passwordLengthErrorText },
  } = this.props;
  const { createPasswordNewPassword } = this.state;

  if (createPasswordNewPassword.length < 6) {
    this.setState({
      createPasswordGenericError: passwordLengthErrorText,
    });

    return;
  }

  setCreatePasswordErrors.bind(this)(hasErrors => {
    if (!hasErrors && !isGoogle) {
      this.onAppleLinking();
    } else if (!hasErrors && isGoogle) {
      this.onRegisterWithGoogle();
    }
  });
}

function onCreatePasswordBackClick() {
  this.toggleCreatePassword();
  this.toggleAccountMain();
}

export default function renderCreatePassword() {
  const {
    language: { profileChangePw_header: headerText, profileSignin_forgotPasswordText: linkText },
    language,
    backgroundClass,
    isMobile,
    utagAccountSource,
  } = this.props;
  const {
    createPasswordNewPassword,
    createPasswordShowNewPassword,
    createPasswordGenericError,
    createPasswordNewPasswordError,
    showLinkToProfile,
    googleLinkingError,
    showCreatePassword,
    userEmail,
  } = this.state;

  const createPasswordBackClick = onCreatePasswordBackClick.bind(this);
  const createPassword = onCreatePassword.bind(this);
  const forgotPasswordCTAProps = {
    linkText,
    onClick: () => {
      if (this.onForgotPasswordClick) this.onForgotPasswordClick();
    },
  };

  const onCTAClick = () => {
    this.setState({
      showCreatePassword: false,
      showShareMyEmailUpsell: false,
      showLinkAccount: true,
      appleLinkingEmail: '',
    });
  };

  const headerProps = {
    headerText,
    iconMobile: <button onClick={() => createPasswordBackClick()} className={Style.back} />,
    isDesktop: !isMobile,
    onClose: this.onClose,
    renderLogo: this.renderLogo,
    showHeaderDesktop: true,
  };
  const createPasswordProps = {
    backgroundClass,
    createPasswordGenericError,
    createPasswordNewPassword,
    createPasswordNewPasswordError,
    createPasswordShowNewPassword,
    googleLinkingError,
    forgotPasswordCTAProps,
    headerProps,
    language,
    onCreatePassword: createPassword,
    onCreatePasswordBackClick: createPasswordBackClick,
    onCTAClick,
    onFieldChange: this.onFieldChange,
    showLinkToProfile,
    userEmail,
    utagAccountSource,
  };
  if (!showCreatePassword) return null;
  return <CreatePassword {...createPasswordProps} />;
}
